export default __webpack_public_path__ + "static/media/img4.567d5667.jpg";